export const MIGRATION_LOADED = '[SOL Migration] MIGRATION_LOADED';
export const RESET_MIGRATION = '[SOL Migration] RESET_MIGRATION';
export const SET_MIGRATION_DATA = '[SOL Migration] SET_MIGRATION_DATA';
export const TOGGLE_MIGRATION_LOADED =
  '[SOL Migration] TOGGLE_MIGRATION_LOADED';
